<legend>
    <h4>Select location</h4>
</legend>
<div class="row">
    <div class="col-lg-12">
        <mat-form-field class="search_text">
            <!-- <app-google-search-autocomplete style="padding: 0;" class="searchTerm" (setAddress)="getAddress($event);" [adressType]="geocode" [(ngModel)]="google_search">
            </app-google-search-autocomplete> -->

            <input [(ngModel)]="google_search" type="search" (input)="setTimer()" matInput placeholder="Search"
                style="width: 100%;" #addresstext />
            <!-- <mat-icon matSuffix (click)="getPlaceByAddress()" class="pointer">search</mat-icon> -->
            <mat-icon matSuffix (click)="getCurrentLocation()" class="pointer" title="Your current location">my_location
            </mat-icon>

        </mat-form-field>
        <div>
            <mat-progress-bar *ngIf="!show_map" style="width:100%; margin-top: -20px; font-size: large;"
                mode="indeterminate" aria-valuenow="100">Loading...</mat-progress-bar>
        </div>

    </div>
</div>
<mat-dialog-content class="fullscreen-dialog" style="margin-top: -1rem; overflow:hidden;">
    <!-- <google-map class="map-canvas" width="100%" height="407px" [zoom]="zoom" [center]="center" [options]="options"
        (mapClick)="click($event)">

        <map-marker #markerElem *ngFor="let marker of markers" [position]="marker.position" [label]="marker.label"
            [title]="marker.title" [options]="marker.options">
        </map-marker>

        <map-info-window>{{ infoContent }}</map-info-window>
    </google-map> -->
    <div id="legend"></div>
</mat-dialog-content>
<mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <div class="ml-auto">
        <button class=" btn close-btn" style="background-color:#22295d;color:white" mat-raised-button (click)="close()">
            <span *ngIf="loading">
                <i class="fa fa-spin fa-spinner"></i>
            </span>
            <span *ngIf="!loading">
                {{ "Select" | translate }}
            </span>
        </button>
        <button class=" btn close-btn" mat-raised-button (click)="close1()">
            <span *ngIf="loading">
                <i class="fa fa-spin fa-spinner"></i>
            </span>
            <span *ngIf="!loading">
                {{ "Cancel" | translate }}
            </span>
        </button>

    </div>
</mat-dialog-actions>